module.exports = __webpack_public_path__ + "img/IMG_7066.5c17b809.webp";